export default function CardResultadoLista({participantes, mulheres, jovens, associacoes}) {
    return(
        <div>
            <p>participantes: {participantes}</p>
            <p>mulheres: {mulheres}</p>
            <p>jovens: {jovens}</p>
            <p>organizações sociais: {associacoes}</p>
        </div>
    )
}